import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAtendimento from "../../hooks/useAtendimento";
import { useAtendimentoAtual } from "../../hooks/useAtendimentoAtual";
import { useAuth } from "../../auth/AuthContext";
import { formatarNomeUpper} from "../../utils/formatadores"

const Atendimento = () => {
  const { fila, iniciarAtendimento } = useAtendimento();
  const navigate = useNavigate();
  const { setAtendimentoId } = useAtendimentoAtual();
  const { user, loading } = useAuth();
  const [loadingId, setLoadingId] = useState(null);

  if (loading) return <p>Carregando...</p>;
  if (!user) return <p>Não autorizado</p>;

  const atender = async (atendimento) => {
    if (loadingId) return; // Evita duplo clique
    setLoadingId(atendimento._id);

    try {
      // 1. Executa a API sem recarregar a fila
      await iniciarAtendimento(atendimento._id, false); 
      
      // 2. Atualiza o Contexto (se houver)
      if (setAtendimentoId) {
        setAtendimentoId(atendimento._id);
      }

      // 3. Navega enviando o ID no state da rota (garante que a ficha receba de imediato)
      navigate("/atendimento/ficha-atendimento", { 
        state: { atendimentoId: atendimento._id },
        replace: true // Usa 'replace' para não deixar voltar no histórico
      });
    } catch (error) {
      console.error("Erro ao iniciar atendimento:", error);
      alert("Não foi possível iniciar o atendimento.");
      setLoadingId(null);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h1>Fila de Atendimento</h1>

        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Horário</th>
                <th>Status</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {fila.map((item) => (
                <tr key={item._id}>
                  <td>{formatarNomeUpper(item.cliente?.nomeCliente)}</td>
                  <td>{new Date(item.horarioCheckin).toLocaleString()}</td>
                  <td>{item.status}</td>
                  <td>
                    <button 
                      className="botao-primary"
                      onClick={() => atender(item)}
                      disabled={loadingId !== null}
                    >
                      {loadingId === item._id ? "Atendendo..." : "Atender"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Atendimento;